import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const productLedgerURL = "api/v1/account-app/product-ledger";

//for sumamry data
export const getProductLedgerReportData = ({ rowsPerPage, search, sortOrder, pageNo, product, branch }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${productLedgerURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}&product=${product}&branch=${branch}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

export const getProductLedgerPrevious = (previous) => axiosInstance.get(previous);

export const getProductLedgerNext = (next) => axiosInstance.get(next);

export const getProductLedgerParticularPage = ({ number, rowsPerPage, search, product, branch }) =>
  axiosInstance.get(
    `${productLedgerURL}/list?${paginationQueryParams(
      rowsPerPage,
      search,
      "",
      number
    )}&product=${product}&branch=${branch}`
  );
